/* eslint-disable @typescript-eslint/no-explicit-any */
export class CustomError extends Error {
    constructor(
        message: string,
        private errorDetails: any,
        stack?: string,
        private context = process.env.SERVICE_NAME || 'QrveyCustomError',
    ) {
        super(message);
        this.name = 'ERROR in ' + this.context;
        this.stack = stack;
    }

    toJSON() {
        return {
            name: this.name,
            message: this.message,
            stack: this.stack,
            details: this.errorDetails,
        };
    }
}
